export enum PatientTabType {
  StickyNote = 'sticky-note',
  CareTeam = 'care-team',
  PatientSettings = 'patient-settings',
  MedicalInfo = 'medical-info'
}
